import { NgModule } from '@angular/core';
import { GoAppsCommunModule } from './common-mobile-apps.module';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [],
  imports: [GoAppsCommunModule],
  providers: [],
})
export class GoAppModule {}

export const goAppImports =
  environment.mode === 'Customer' ? [GoAppModule] : [];
